// extracted by mini-css-extract-plugin
export default {"link":"modal_link__M24F0","linkTitle":"modal_linkTitle__QLrN4","linkText":"modal_linkText__jr82y"};